<template>
  <alert-banner v-if="bannerDetails.message" :status="bannerDetails.status" class="w-full sticky z-[9] top-48 lg:top-82">
    <template v-if="bannerDetails.icon" #icon>
      <component :is="bannerDetails.icon" :width="24" :height="24" :color="bannerDetails.iconColor" />
    </template>

    {{ bannerDetails.message }}
    <a
      v-if="bannerType === BannerType.PROFILE_HIDDEN"
      href="#"
      class="underline font-medium"
      @click.once="$emit('toggle-profile-visibility')"
      >Click to unhide
    </a>
  </alert-banner>
</template>

<script lang="ts">
import HelperStatus from '@/helpers/status';
import { BannerType } from '../__types__/BannerTypes';
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import PencilIcon from '@/graphics/icons/PencilIcon.vue';
import PasswordShowOutlineIcon from '@/graphics/icons/PasswordShowOutlineIcon.vue';

export default {
  name: 'ProviderProfileBanner',
  components: {
    AlertBanner,
  },
  props: {
    bannerType: {
      type: String,
      default: BannerType.NONE,
    },
    profileEditModeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      HelperStatus,
      BannerType,
    };
  },
  computed: {
    bannerDetails(): any {
      if (this.bannerType === BannerType.PROFILE_HIDDEN) {
        return {
          message: "Profile hidden: Families can't find or contact you for this service when it's hidden.",
          status: HelperStatus.Warn,
        };
      }

      if (this.profileEditModeEnabled && this.bannerType === BannerType.PROFILE_EDIT_MODE) {
        return {
          message: 'Editing: This view is only visible to you',
          status: HelperStatus.Recruit,
          icon: PencilIcon,
          iconColor: '#99005c',
        };
      }
      if (this.profileEditModeEnabled && this.bannerType === BannerType.PROFILE_PREVIEW_MODE) {
        return {
          message: 'Preview: This is how families see your profile',
          status: HelperStatus.Trust,
          icon: PasswordShowOutlineIcon,
          iconColor: '#005988',
        };
      }

      return {
        message: '',
        status: null,
      };
    },
  },
};
</script>
